import EmojiConvertor from 'emoji-js'
import {i18n} from '@/plugins/i18n'

const emojiConvertor = new EmojiConvertor()
emojiConvertor.init_unified()
emojiConvertor.init_colons()

emojiConvertor.replace_mode = 'img'
emojiConvertor.supports_css = false // needed to avoid spans with background-image

const emojiRegex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug
function getDynamicPath(icon) {
  return require( `../../node_modules/emoji-datasource-apple/img/apple/64/${icon.toLowerCase()}.png`);
}

// global data
export const helper = {
  data: () => ({
    types: {
      TextMessage: 0,
      ImageMessage: 1,    // Image file
      LocationMessage: 2, // GPS coordinates
      ContactMessage: 3,  // User contact id
      TimerMessage: 4,
      VideoMessage: 5,    // Video file
      DocumentMessage: 6, // Any attachment
      AudioMessage: 7,    // Audio file  
      UserLeftMessage: 8,
      UserAddedMessage: 9,
      RemoveMessage: 10,
      ChatDetailsMessage: 11,

      DateMessage: 30, //local additional types
      TypingMessage: 31,
      
      isFileType: function(type) {
        return (
          type === this.ImageMessage ||
          type === this.VideoMessage ||
          type === this.DocumentMessage ||
          type === this.AudioMessage
        ) 
      }
    },
    states:{
      MessageCreated: 0,
      MessageSent: 1,
      MessageDelivered: 2,
      MessageRead: 3,
      MessageFailed: 4,
      MessagePending: 5,
      MessageSending: 6,
      MessageSuspended: 7,
      MessageInvalid: 8,
      MessageBlocked: 9,
    }
  }),
  methods: {
    getHumanTime: (when) => {
      const now = new Date()
      const date = new Date(when)
      const seconds = (now.getTime() - date.getTime()) / 1000
      if (seconds <= 86400 && now.getDay() == date.getDay()) {
        let hh = date.getHours()
        let mm = date.getMinutes()
        if (hh < 10) hh = '0' + hh
        if (mm < 10) mm = '0' + mm
        return hh + ':' + mm
      }
      if (seconds <= 86400 * 7) {
        return date.toLocaleDateString(i18n.locale, { weekday: 'short' })
      }
      if (now.getFullYear() - date.getFullYear() > 1) {
        return date.getFullYear()
      }
      return date.toLocaleDateString(i18n.locale, { day: 'numeric', month: 'short' })
    },
    getTimerString(ttl) {
      if (ttl == 1)
        return '1 ' + this.$t('second')
      if (ttl >= 2 && ttl < 60)
        return ttl + ' ' + this.$t('seconds')
      if (ttl >= 60 && ttl < 120)
        return '1 ' + this.$t('minute')
      if (ttl >= 120 && ttl < 3600)
          return (ttl / 60) + ' ' + this.$t('minutes')
      if (ttl == 3600)
          return '1 ' + this.$t('hour')
      if (ttl == (3600 * 24))
        return '1 ' + this.$t('day')
      if (ttl == (3600 * 24 * 7))
        return '1 ' + this.$t('week')
      if (ttl == (3600 * 24 * 30))
        return '1 ' + this.$t('month')
      if (ttl == (3600 * 24 * 30 * 6))
        return '6 ' + this.$t('months')
      if (ttl == (3600 * 24 * 365))
        return '1 ' + this.$t('year')
      return ttl;
    },

    composeImageWithDynamicPath(imageUnifiedCode) {
      return `<img src="${getDynamicPath(imageUnifiedCode.toLowerCase())}" class="emoji" data-codepoints="${imageUnifiedCode.toLowerCase()}">`
    },
   
    replaceUnified(emoji) {
      return (emoji) ? this.composeImageWithDynamicPath(emoji.codePointAt(0).toString(16).toLowerCase()) : ''
    },

    replaceEmoji(text) {
      let emojis = text.match(emojiRegex)
      if (emojis != null) {
        emojis.forEach(em => {
          text = text.replace(em, this.replaceUnified(em))
        })
      }
      return text
    },
    matchEmoji(text) {
      return text.match(emojiRegex)
    },
    escapeHtml(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    safeTextWithEmoji(text) {
      text = this.escapeHtml(text)
      if (this.matchEmoji(text)) 
        text = this.replaceEmoji(text)
      return text
    }
  }
}
